import {ListingSummary, toListingSummary} from '../utils/listing-summary.util';

export class PaginationModel<T> {
  pageCount!: number;
  pageSize!: number;
  totalCount!: number;
  currentPage!: number;
  data!: T[];
  /**
   * Aggregates over the WHOLE filtered set, when the request asked for them
   * (`RequestParamModel.summary = true`). Null otherwise — this page of rows carries
   * no claim about the rest of the set. See utils/listing-summary.util.
   */
  summary: ListingSummary | null = null;
  setHeaders(headers: import('@angular/common/http').HttpHeaders): any {
    this.totalCount = +headers.get('X-Pagination-Total-Count')!;
    this.pageSize = +headers.get('X-Pagination-Per-Page')!;
    this.pageCount = +headers.get('X-Pagination-Page-Count')!;
    this.currentPage = +headers.get('X-Pagination-Current-Page')!;
    this.summary = toListingSummary(headers);
  }
}

